import { NavLink, useNavigate } from "react-router-dom";
import { Appcontext } from "./Reducercontext";
import { useContext } from "react";

function Navbar() {
  const navigate = useNavigate();
  const usecart = useContext(Appcontext);

  const handleLogout = () => {
    console.log("Logout clicked");
    localStorage.removeItem("authtoken");
    localStorage.removeItem("useremail");
    setTimeout(() => {
      navigate("/login", { replace: true });
    }, 0);
  };

  const isLoggedIn = !!localStorage.getItem("authtoken");

  return (
    <div className="navbar" style={{ padding: "0 10px" }}>
      <nav
        className="navbar navbar-expand-lg"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          minHeight: "30px",
          gap: "1rem",
        }}
      >
        {/* Left side */}
        <div
          style={{
            display: "flex",
            gap: "2rem",
            alignItems: "center",
          }}
        >
          <NavLink className="navbar-brand" to="/">
            Food-Bank
          </NavLink>

          {/* Only show links if logged in */}
          {isLoggedIn && (
            <>
             
              <NavLink
                className="nav-item nav-link active home"
                to="/"
                style={{ flexGrow: 1, whiteSpace: "nowrap" }}
              >
                Home
              </NavLink>
            </>
          )}

          {/* Show Login/Register if NOT logged in */}
          {!isLoggedIn && (
            <>
              <NavLink className="nav-item nav-link login" to="/login">
                Login
              </NavLink>
              <NavLink className="nav-item nav-link register" to="/register">
                Register
              </NavLink>
            </>
          )}
        </div>

        {/* Right side */}
        {isLoggedIn && (
          <div
            style={{
              display: "flex",
              gap: "2rem",
              alignItems: "center",
              minWidth: "150px",
              justifyContent: "flex-end",
            }}
          >
            <NavLink
              className="nav-item nav-link mycart"
              to="/mycart"
              style={{ whiteSpace: "nowrap" }}
            >
              MyCart <span className="length">{usecart.length}</span>
            </NavLink>
            <NavLink
              className="nav-item nav-link logout"
              onClick={handleLogout}
              style={{ cursor: "pointer", whiteSpace: "nowrap" }}
            >
              Logout
            </NavLink>
          </div>
        )}
      </nav>
    </div>
  );
}

export default Navbar;
